import * as actionTypes from './actionTypes';

export const loginSuccess = (val) => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    val: val
  }
}

export const updateUserSuccess = (val) => {
  return {
    type: actionTypes.UPDATE_USER_SUCCESS,
    val: val
  }
}

// addStoryCount

export const storyMetricsChange = (val) => {
  return {
    type: actionTypes.STORY_METRICS_CHANGE,
    val: val
  }
}

export const setStoryActivity = (val) => {
  return {
    type: actionTypes.SET_STORY_ACTIVITY,
    val: val
  }
}

export const subtractStoryCount = (val) => {
  return {
    type: actionTypes.SUBTRACT_STORY_COUNT,
    val: val
  }
}


export const updateProfileInfoSuccess = (val) => {
  return {
    type: actionTypes.UPDATE_PROFILE_INFO_SUCCESS,
    val: val
  }
}

export const logout = () => {
  return {
    type: actionTypes.LOGOUT
  }
}

export const changePasswordSuccess = (val) => {
  return {
    type: actionTypes.CHANGE_PASSWORD_SUCCESS
  }
}

export const resetLinkSent = (val) => {
  return {
    type: actionTypes.RESET_PASSWORD_LINK_SENT
  }
}

export const industryChangeSuccess = (val) => {
  return {
    type: actionTypes.INDUSTRY_CHANGE_SUCCESS,
    val : val
  }
}

export const enterpriseNameChange = (val)=>{
  return {
    type: actionTypes.ENTERPRISE_NAME_CHANGE_SUCCESS,
    val:val
  };
}

export const orgSetupSkipped = (val) => {
  return {
    type: actionTypes.SKIPPED_ORG_SETUP,
    val : val
  }
}

export const orgChangeSuccess = (val) => {
  return {
    type: actionTypes.ORG_CHANGE_SUCCESS,
    val : val
  }
}

export const saveNewHierarchy = (payload)=> {
  console.log('new---', payload)
  return {
    type: actionTypes.SAVE_NEW_HIERARCHY,
    val: payload
  }
}


export const orgHierarchyChange = (val) => {
  return {
    type: actionTypes.ORG_HIER_CHANGE,
    val : val
  }
}


export const orgEmailRemove = (val) => {
  return {
    type: actionTypes.ORG_REMOVE_EMAIL,
    val : val
  }
}
export const orgSlackUrlRemove = (val) => {
  return {
    type: actionTypes.ORG_REMOVE_SLACK_URL,
    val : val
  }
}
export const orgTenantIdRemove = (val) => {
  return {
    type: actionTypes.ORG_REMOVE_TEAMS_TENANT,
    val : val
  }
}

export const setReturnUrlAfterSlackTeamsAuth = (val) => {
  return {
    type: actionTypes.USER_SET_SLACK_TEAMS_AFTERAUTH_RETURN_URL,
    payload : val
  }
}

export const setAfterLoginUrl = (val) => {
  return {
    type: actionTypes.SET_AFTER_LOGIN_REDIRECT,
    payload : val
  }
}